import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#b31117',
        },
        secondary: {
            main: '#e5a100',
        },
    },
});

export default theme;
